import { render, staticRenderFns } from "./courseLeaveManage.vue?vue&type=template&id=71f1d864&scoped=true&"
import script from "./courseLeaveManage.vue?vue&type=script&lang=js&"
export * from "./courseLeaveManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1d864",
  null
  
)

export default component.exports